import { useState, useEffect } from 'react'
import { VITE_API_BASE } from '../config/apiConfig'

const API = VITE_API_BASE

// V2.0 推广员体系
const PROMO_TYPES = {
  personal: { 
    name: '个人推广员', 
    color: '#13c2c2', 
    fee: '免费注册', 
    commission: { 'AI动画单次': '30%', 'AI动画10次': '40%', 'AI动画30次': '50%', '线上课程': '60%', '会员': '60%' }
  },
  certified: { 
    name: '认证推广员', 
    color: '#722ed1', 
    fee: '¥5,000/年', 
    commission: { 'AI动画单次': '40%', 'AI动画10次': '50%', 'AI动画30次': '60%', '线上课程': '80%', '会员': '80%' },
    extra: ['可招募下线', '管理奖20%']
  },
  agency: { 
    name: '机构推广合伙人', 
    color: '#fa8c16', 
    fee: '¥5,000/年+SaaS', 
    commission: { 'AI动画单次': '50%', 'AI动画10次': '60%', 'AI动画30次': '70%', '线上课程': '80%', '会员': '80%' },
    extra: ['线下活动利润100%', '可招募下线', '前提:购买SaaS']
  }
}

export default function PartnerLogin() {
  const [phone, setPhone] = useState('')
  const [password, setPassword] = useState('')
  const [promoType, setPromoType] = useState('personal')
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState('')
  const [dashboard, setDashboard] = useState(null)
  const [showDownline, setShowDownline] = useState(false)

  const handleLogin = async () => {
    if (!phone || !password) { setError('请输入手机号和密码'); return }
    setLoading(true)
    setError('')
    try {
      const res = await fetch(`${API}/partners/login`, {
        method: 'POST', 
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ phone, password })
      })
      const data = await res.json()
      if (data.success) {
        localStorage.setItem('partner_token', data.token || phone)
        localStorage.setItem('partner_info', JSON.stringify(data.data))
        localStorage.setItem('promo_type', promoType)
        setDashboard(data.data)
      } else { 
        setError(data.error || '手机号或密码错误') 
      }
    } catch (err) { 
      setError('网络错误，请重试') 
    }
    finally { setLoading(false) }
  }

  const loadDashboard = async (token) => {
    try {
      const res = await fetch(`${API}/partner-auth/partner-dashboard/me`, { headers: { Authorization: token } })
      const data = await res.json()
      if (data.success) setDashboard(data.data)
    } catch (err) { console.error('获取看板失败', err) }
  }
  useEffect(() => {
    // 页面加载时尝试恢复登录状态
    const saved = localStorage.getItem('partner_info')
    const savedType = localStorage.getItem('promo_type')
    if (saved && savedType) {
      setDashboard(JSON.parse(saved))
      setPromoType(savedType)
    }
  }, [])

  const handleLogout = () => {
    localStorage.removeItem('partner_token')
    localStorage.removeItem('partner_info')
    localStorage.removeItem('promo_type')
    setDashboard(null)
    setPhone('')
    setPassword('')
    setShowDownline(false)
  }

  const currentPromo = PROMO_TYPES[promoType]

  if (dashboard) {
    const downlines = dashboard.downlines || []
    const totalDownlineCommission = downlines.reduce((sum, d) => sum + (d.total_commission || 0), 0)
    const manageReward = totalDownlineCommission * 0.2

    return (
      <div>
        <h2 style={{ fontSize: 20, marginBottom: 20 }}>👥 {currentPromo.name} 中心</h2>
        
        {/* 头部信息 */}
        <div style={{ background: `linear-gradient(135deg, ${currentPromo.color} 0%, ${currentPromo.color}88 100%)`, borderRadius: 12, padding: 24, color: '#fff', marginBottom: 20 }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <div>
              <div style={{ fontSize: 20, fontWeight: 600 }}>{dashboard.name || '推广员'}</div>
              <div style={{ opacity: 0.9, marginTop: 4 }}>{currentPromo.name}</div>
              {dashboard.expire_at && (
                <div style={{ fontSize: 11, opacity: 0.8, marginTop: 4 }}>
                  体验期至：{new Date(dashboard.expire_at).toLocaleDateString()}
                </div>
              )}
            </div>
            <div style={{ textAlign: 'right' }}>
              <div style={{ fontSize: 12, opacity: 0.8 }}>当前佣金比例</div>
              <div style={{ fontSize: 24, fontWeight: 700 }}>{currentPromo.commission['线上课程']}</div>
            </div>
          </div>
        </div>

        {/* 统计卡片 */}
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: 16, marginBottom: 20 }}>
          {[
            { label: '可提现', value: '¥' + ((dashboard.balance || 0)).toLocaleString(), color: '#fa8c16' },
            { label: '累计收益', value: '¥' + ((dashboard.total_commission || 0)).toLocaleString(), color: '#52c41a' },
            { label: '下线人数', value: downlines.length, color: '#722ed1' },
            { label: '下线总佣金', value: '¥' + totalDownlineCommission.toLocaleString(), color: '#1890ff' },
          ].map(s => (
            <div key={s.label} style={{ background: '#fff', borderRadius: 12, padding: 20, textAlign: 'center' }}>
              <div style={{ fontSize: 24, fontWeight: 600, color: s.color }}>{s.value}</div>
              <div style={{ fontSize: 13, color: '#666', marginTop: 4 }}>{s.label}</div>
            </div>
          ))}
        </div>

        {/* 管理奖展示 */}
        <div style={{ background: '#fff', borderRadius: 12, padding: 20, marginBottom: 20, border: '2px solid #722ed1' }}>
          <h4 style={{ fontSize: 14, marginBottom: 12, color: '#722ed1' }}>👥 下线管理奖</h4>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: 16 }}>
            <div style={{ textAlign: 'center', padding: 16, background: '#f5f5f5', borderRadius: 8 }}>
              <div style={{ fontSize: 12, color: '#666', marginBottom: 4 }}>下线佣金合计</div>
              <div style={{ fontSize: 24, fontWeight: 700, color: '#1890ff' }}>¥{totalDownlineCommission.toLocaleString()}</div>
            </div>
            <div style={{ textAlign: 'center', padding: 16, background: '#f5f5f5', borderRadius: 8 }}>
              <div style={{ fontSize: 12, color: '#666', marginBottom: 4 }}>管理奖比例</div>
              <div style={{ fontSize: 24, fontWeight: 700, color: '#722ed1' }}>20%</div>
            </div>
            <div style={{ textAlign: 'center', padding: 16, background: '#722ed1', borderRadius: 8 }}>
              <div style={{ fontSize: 12, color: '#fff', opacity: 0.9, marginBottom: 4 }}>可获得管理奖</div>
              <div style={{ fontSize: 24, fontWeight: 700, color: '#fff' }}>¥{manageReward.toLocaleString()}</div>
            </div>
          </div>
          <div style={{ marginTop: 12, fontSize: 12, color: '#666', background: '#fff7e6', padding: 8, borderRadius: 4 }}>
            💡 下线每产生一笔佣金，您将自动获得该佣金的20%作为管理奖
          </div>
        </div>

        {/* Tab切换：我的佣金 / 下线管理 */}
        <div style={{ display: 'flex', gap: 4, marginBottom: 16, background: '#f5f5f5', padding: 4, borderRadius: 8, width: 'fit-content' }}>
          <button 
            onClick={() => setShowDownline(false)}
            style={{ padding: '8px 20px', background: !showDownline ? '#fff' : 'transparent', border: 'none', borderRadius: 6, cursor: 'pointer', fontWeight: !showDownline ? 600 : 400 }}
          >
            我的佣金
          </button>
          <button 
            onClick={() => setShowDownline(true)}
            style={{ padding: '8px 20px', background: showDownline ? '#fff' : 'transparent', border: 'none', borderRadius: 6, cursor: 'pointer', fontWeight: showDownline ? 600 : 400 }}
          >
            下线管理 {downlines.length > 0 && <span style={{ background: '#722ed1', color: '#fff', padding: '2px 6px', borderRadius: 10, fontSize: 11, marginLeft: 4 }}>{downlines.length}</span>}
          </button>
        </div>

        {/* 我的佣金 */}
        {!showDownline && (
          <div style={{ background: '#fff', borderRadius: 12, padding: 20, marginBottom: 20 }}>
            <h4 style={{ fontSize: 14, marginBottom: 12 }}>💰 佣金比例（{currentPromo.name}）</h4>
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(5, 1fr)', gap: 12 }}>
              {Object.entries(currentPromo.commission).map(([product, rate]) => (
                <div key={product} style={{ textAlign: 'center', padding: 12, background: '#fafafa', borderRadius: 8 }}>
                  <div style={{ fontSize: 12, color: '#666', marginBottom: 4 }}>{product}</div>
                  <div style={{ fontSize: 18, fontWeight: 600, color: '#52c41a' }}>{rate}</div>
                </div>
              ))}
            </div>
            {currentPromo.extra && (
              <div style={{ marginTop: 12, padding: 12, background: `${currentPromo.color}11`, borderRadius: 8 }}>
                <div style={{ fontSize: 13, color: '#666' }}>
                  <strong>额外权益：</strong>
                  {currentPromo.extra.map((e, i) => <span key={i} style={{ marginLeft: 12, color: currentPromo.color }}>✓ {e}</span>)}
                </div>
              </div>
            )}
          </div>
        )}

        {/* 下线管理 */}
        {showDownline && (
          <div style={{ background: '#fff', borderRadius: 12, padding: 20, marginBottom: 20 }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 16 }}>
              <h4 style={{ fontSize: 14, margin: 0 }}>👥 我的下线（{downlines.length}人）</h4>
            </div>
            
            {downlines.length === 0 ? (
              <div style={{ textAlign: 'center', padding: 40, color: '#999' }}>
                <div style={{ fontSize: 48, marginBottom: 12 }}>👥</div>
                <div>暂无下线</div>
                <div style={{ fontSize: 12, marginTop: 8 }}>分享您的推广链接邀请下级推广员</div>
              </div>
            ) : (
              <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                <thead>
                  <tr style={{ background: '#f5f5f5' }}>
                    <th style={{ padding: 12, textAlign: 'left', fontSize: 12, color: '#666' }}>下线ID</th>
                    <th style={{ padding: 12, textAlign: 'left', fontSize: 12, color: '#666' }}>姓名</th>
                    <th style={{ padding: 12, textAlign: 'left', fontSize: 12, color: '#666' }}>手机</th>
                    <th style={{ padding: 12, textAlign: 'center', fontSize: 12, color: '#666' }}>级别</th>
                    <th style={{ padding: 12, textAlign: 'right', fontSize: 12, color: '#666' }}>累计佣金</th>
                    <th style={{ padding: 12, textAlign: 'right', fontSize: 12, color: '#666' }}>贡献管理奖</th>
                  </tr>
                </thead>
                <tbody>
                  {downlines.map(d => (
                    <tr key={d.id} style={{ borderBottom: '1px solid #f0f0f0' }}>
                      <td style={{ padding: 12, fontSize: 12, fontFamily: 'monospace' }}>{d.id}</td>
                      <td style={{ padding: 12, fontSize: 12 }}>{d.name}</td>
                      <td style={{ padding: 12, fontSize: 12 }}>{d.phone}</td>
                      <td style={{ padding: 12, textAlign: 'center', fontSize: 11 }}>
                        <span style={{ padding: '2px 8px', background: '#722ed111', color: '#722ed1', borderRadius: 4 }}>
                          {d.level || '推广员'}
                        </span>
                      </td>
                      <td style={{ padding: 12, textAlign: 'right', fontSize: 12, color: '#52c41a', fontWeight: 500 }}>
                        ¥{(d.total_commission || 0).toLocaleString()}
                      </td>
                      <td style={{ padding: 12, textAlign: 'right', fontSize: 12, color: '#722ed1', fontWeight: 600 }}>
                        ¥{((d.total_commission || 0) * 0.2).toLocaleString()}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            )}
          </div>
        )}

        {/* 推广链接 */}
        <div style={{ background: '#fff', borderRadius: 12, padding: 20, marginBottom: 20 }}>
          <h4 style={{ fontSize: 14, marginBottom: 12 }}>🔗 我的推广链接</h4>
          <div style={{ display: 'flex', gap: 8 }}>
            <input 
              type="text" 
              readOnly 
              value={`${window.location.origin}/partner/?page=partner-apply&ref=${dashboard.id || ''}`}
              style={{ flex: 1, padding: '10px 12px', border: '1px solid #d9d9d9', borderRadius: 6, fontSize: 13 }}
            />
            <button 
              onClick={() => navigator.clipboard.writeText(`${window.location.origin}/partner/?page=partner-apply&ref=${dashboard.id || ''}`)}
              style={{ padding: '10px 16px', background: currentPromo.color, color: '#fff', border: 'none', borderRadius: 6, cursor: 'pointer' }}
            >
              复制
            </button>
          </div>
          <div style={{ marginTop: 8, fontSize: 12, color: '#666' }}>
            💡 分享此链接给其他人，他们注册时会自动成为您的下线
          </div>
        </div>

        <button onClick={handleLogout} style={{ width: '100%', marginTop: 20, padding: 12, background: '#f5f5f5', border: 'none', borderRadius: 6, cursor: 'pointer' }}>
          退出登录
        </button>
      </div>
    )
  }

  return (
    <div>
      <h2 style={{ fontSize: 20, marginBottom: 20 }}>👥 推广员登录</h2>
      
      {/* 类型选择 */}
      <div style={{ background: '#fff', borderRadius: 12, padding: 24, marginBottom: 20 }}>
        <label style={{ display: 'block', marginBottom: 12, fontSize: 14, color: '#666' }}>选择推广身份</label>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: 12 }}>
          {Object.entries(PROMO_TYPES).map(([key, info]) => (
            <div
              key={key}
              onClick={() => setPromoType(key)}
              style={{
                padding: 16,
                border: '2px solid',
                borderColor: promoType === key ? info.color : '#e8e8e8',
                background: promoType === key ? `${info.color}11` : '#fff',
                borderRadius: 8,
                cursor: 'pointer',
                textAlign: 'center'
              }}
            >
              <div style={{ fontSize: 16, fontWeight: 600, color: promoType === key ? info.color : '#666' }}>{info.name}</div>
              <div style={{ fontSize: 13, color: '#999', marginTop: 4 }}>{info.fee}</div>
              {info.extra && (
                <div style={{ fontSize: 11, color: info.color, marginTop: 8 }}>
                  {info.extra.map((e, i) => <span key={i}>✓ {e} </span>)}
                </div>
              )}
            </div>
          ))}
        </div>
      </div>

      {/* 登录表单 */}
      <div style={{ background: '#fff', borderRadius: 12, padding: 24, maxWidth: 450 }}>
        <div style={{ marginBottom: 16 }}>
          <label style={{ display: 'block', fontSize: 14, marginBottom: 8, color: '#666' }}>手机号</label>
          <input 
            type="tel" 
            value={phone} 
            onChange={e => setPhone(e.target.value)} 
            placeholder="请输入手机号" 
            maxLength={11} 
            style={{ width: '100%', padding: '12px', border: '1px solid #d9d9d9', borderRadius: 6, fontSize: 14, boxSizing: 'border-box' }} 
          />
        </div>
        <div style={{ marginBottom: 24 }}>
          <label style={{ display: 'block', fontSize: 14, marginBottom: 8, color: '#666' }}>验证码</label>
          <div style={{ display: 'flex', gap: 8 }}>
            <input 
              type="text" 
              value={code} 
              onChange={e => setCode(e.target.value)} 
              placeholder="请输入验证码" 
              maxLength={6} 
              style={{ flex: 1, padding: '12px', border: '1px solid #d9d9d9', borderRadius: 6, fontSize: 14 }} 
            />
            <button style={{ padding: '12px 16px', background: '#f5f5f5', border: '1px solid #d9d9d9', borderRadius: 6, cursor: 'pointer', fontSize: 13 }}>
              获取验证码
            </button>
          </div>
          <div style={{ marginTop: 8, fontSize: 12, color: '#1890ff' }}>演示验证码：123456</div>
        </div>
        {error && (
          <div style={{ padding: 12, background: '#fff1f0', color: '#f5222d', borderRadius: 6, marginBottom: 16, fontSize: 13 }}>
            {error}
          </div>
        )}
        <button 
          onClick={handleLogin} 
          disabled={loading} 
          style={{ 
            width: '100%', 
            padding: '14px', 
            background: currentPromo.color, 
            color: '#fff', 
            border: 'none', 
            borderRadius: 6, 
            fontSize: 16, 
            cursor: loading ? 'not-allowed' : 'pointer',
            opacity: loading ? 0.7 : 1 
          }}
        >
          {loading ? '登录中...' : '登录'}
        </button>
      </div>

      {/* 佣金说明 */}
      <div style={{ marginTop: 24, background: '#f6ffed', border: '1px solid #b7eb8f', borderRadius: 12, padding: 20, maxWidth: 450 }}>
        <h4 style={{ fontSize: 14, color: '#52c41a', marginBottom: 12 }}>💡 佣金比例说明</h4>
        <div style={{ fontSize: 13, color: '#666', lineHeight: 1.8 }}>
          {Object.entries(PROMO_TYPES).map(([key, info]) => (
            <div key={key} style={{ marginBottom: 12 }}>
              <div style={{ color: info.color, fontWeight: 600 }}>{info.name}（{info.fee}）</div>
              {info.extra && (
                <div style={{ fontSize: 11, color: info.color, marginTop: 4 }}>
                  {info.extra.map((e, i) => <span key={i}>✓ {e} </span>)}
                </div>
              )}
              {Object.entries(info.commission).map(([product, rate]) => (
                <div key={product} style={{ paddingLeft: 16, fontSize: 12 }}>
                  {product}: <strong style={{ color: '#52c41a' }}>{rate}</strong>
                </div>
              ))}
            </div>
          ))}
          <div style={{ marginTop: 12, padding: 8, background: '#722ed1', borderRadius: 4, color: '#fff', fontSize: 12 }}>
            👥 管理奖：认证推广员/机构推广合伙人招募的下线，其佣金的20%归上线所有
          </div>
        </div>
      </div>
    </div>
  )
}
